import { globalValue } from "../GlobalValue.js";
import { fiberRefUnsafeMake } from "./core.js";
/** @internal */
export const currentRequestMap = /*#__PURE__*/globalValue(/*#__PURE__*/Symbol.for("effect/FiberRef/currentRequestMap"), () => fiberRefUnsafeMake(new Map()));
//# sourceMappingURL=completedRequestMap.js.map